function sanitizeBaseUrl(input) {
  const raw = String(input || '').trim();
  const lastHttps = raw.lastIndexOf('https://');
  const lastHttp = raw.lastIndexOf('http://');
  const startIndex = Math.max(lastHttps, lastHttp);
  const extracted = startIndex > 0 ? raw.slice(startIndex) : raw;
  return extracted.replace(/\/+$/, '');
}

const normalizedBaseUrl = sanitizeBaseUrl(process.env.REACT_APP_API_BASE_URL);

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBaseUrl}${normalizedPath}`;
}

export function getApiBaseUrl() {
  return normalizedBaseUrl;
}
